import { render } from "./InterviewProgress.vue?vue&type=template&id=cfd71620"
import script from "./InterviewProgress.vue?vue&type=script&lang=js"
export * from "./InterviewProgress.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__